<template>
        <div style="padding: 0 25px 17px 25px;">
            <Productpay v-show="$route.params.id != 81" @buy='buy' v-model="ppData" />
            <div v-common-display>
                <component  style="padding-top: 20px;" v-bind:is="doc"/>
            </div>
            <!-- <WT8BookInfo v-if="$store.state.isbook"/> -->
        </div>
</template>

<script>
    // @ is an alias to /src
    import Productpay from '@/components/Productpay.vue'
    import config from '@/assets/js/config.js'
    // import WT8BookInfo from '../../components/WT8BookInfo.vue';
    import Vue from 'vue'
    // import VuexMixin from './store/index'
    export default {
        name: 'DetailFill',
        inject: ['appOverFlow','setLoading','popOverShow','paymentShow','orderShow','initOrder'],
        data: () => {
            var self = this
            return {
                ppData: {
                    pic: [],//[require('../../assets/image/p_1.gif'),require('../../assets/image/p_2.gif'),require('../../assets/image/p_3.gif')],
                    name: '',//'文华云主机（赠一个极速行情）',
                    price: 0,//1200,
                    annexationPrice: 0,
                    classify: [],
                    notice: [
                        // '购买该权限可下载<a href="http://cxh.wenhua.com.cn/service.asp?pid=2" target="_blank">文文通</a>获得在线即时服务；',
                        // '期货运行模组支持128个，股票运行模组支持256个。'
                    ],
                    configure: [],
                    authorization: [],
                    stock: 0,
                    unit: '',
                    pwdAddress: ''
                },
                chooseData: {
                    configure: [
                        {
                            id: Math.random(),
                            content: '多账号下单模块<a href="https://rich.wenhua.com.cn/center.asp?pid=7" target="_blank">查看介绍</a>',
                            ismutiple: true,//判断是多账号下单的当前项（手动加入）
                            type: 0
                        },
                        {
                            id: Math.random(),
                            content: '套利交易模块<a href="https://rich.wenhua.com.cn/center.asp?pid=8" target="_blank">查看介绍</a>',
                            type: 1
                        },
                        {
                            id: Math.random(),
                            content: '付费数据模块 - 国内五档数据、境外实时行情数据CME等',
                            type: 2
                        }
                    ],
                    authorization: [
                        {
                            out: 1,
                            isout: 1,
                            ismutex: 5,
                            order: 18,
                            data: 2921,
                            productlink: 'qwe',
                            price: 360,
                            groupprice: 7200,
                            groupid: 0,
                            name: '纽约商品交易所（COMEX）1',
                            productintro: '所包含品种：美豆、美玉米、美豆粕、美豆油、美麦、美燕麦、美稻米、迷你大豆、迷你玉米、迷你小麦、美债2年期、美债5年期、美债10年期、美债长期、迷你道琼斯、微型道琼斯。>>>'
                        },
                        {
                            out: 1,
                            isout: 1,
                            ismutex: 6,
                            order: 18,
                            data: 2931,
                            productlink: 'asd',
                            price: 360,
                            groupprice: 7200,
                            groupid: 0,
                            name: '纽约商品交易所（COMEX）2',
                            productintro: '所包含品种：美豆、美玉米、美豆粕、美豆油、美麦、美燕麦、美稻米、迷你大豆、迷你玉米、迷你小麦、美债2年期、美债5年期、美债10年期、美债长期、迷你道琼斯、微型道琼斯。>>>'
                        },
                        {
                            out: 1,
                            isout: 1,
                            ismutex: 2,
                            order: 18,
                            data: 291,
                            productlink: 'EUREX',
                            price: 360,
                            groupprice: 7200,
                            groupid: 0,
                            name: '纽约商品交易所（COMEX）',
                            productintro: '所包含品种：美豆、美玉米、美豆粕、美豆油、美麦、美燕麦、美稻米、迷你大豆、迷你玉米、迷你小麦、美债2年期、美债5年期、美债10年期、美债长期、迷你道琼斯、微型道琼斯。>>>'
                        },
                        {
                            out: 1,
                            isout: 0,
                            ismutex: 2,
                            order: 18,
                            data: 292,
                            productlink: 'zhongjinsuowudang',
                            price: 600,
                            groupprice: 600,
                            groupid: 0,
                            name: '五档 - 大连商品交易所（DCE）',
                            productintro: '所包括品种：豆粕、豆油、豆一、豆二、棕榈、玉米、淀粉、粳米、鸡蛋、胶板、纤板、塑料、PVC、乙二醇、PP、苯乙烯、焦炭、焦煤、铁矿。&gt;&gt;&gt;<a href="http://www.wenhua.com.cn/Home/ChargeDataDCE" target="_blank">点击查看详细介绍</a>；'
                        }
                    ],
                    maintitle: '7E-基础功能包',
                    subtitle: '7E基础功能包'

                },
                doc: ''
            }
        },
        provide() {
            let self = this
            return {
                changeDocTemplete(id) {
                    let _sault = 'uhvf545Kikb' 
                    import('../doc/'+config.productToDoc[id]+'_doc.vue').then(mod=>{
                        Vue.component('doc_'+_sault+config.productToDoc[id], { ...(mod.default || mod) })
                        self.doc = 'doc_'+_sault+config.productToDoc[id]
                    })
                }
            }
        },
        // mixins: [
        //     {
        //         beforeCreate () {
        //             let self = this
        //             self.$store = VuexMixin
        //         }
        //     }
        // ],
        computed: {
            
        },
        components: {
            Productpay,
            // WT8BookInfo
        },
        watch: {
            "$route": {
                handler (val){
                    if (val.name != 'Detail') return //控制只有路由是本页的时候才走下面的程序
                    var self = this
                    //惰性的加载组件，此处也是注册为全局组件，为了防止后期维护新增的组件冲突，此处加了一个比较混乱的字符来区别
                    let _sault = 'uhvf545Kikb' 
                    import('../doc/'+config.productToDoc[val.params.id]+'_doc.vue').then(mod=>{
                        Vue.component('doc_'+_sault+config.productToDoc[val.params.id], { ...(mod.default || mod) })
                        self.doc = 'doc_'+_sault+config.productToDoc[val.params.id]
                    })

                    this.setLoading(true)
                    //获取产品的详情数据
                    this.$axios({
                        url: "/api/Product/Detail?id="+val.params.id,
                        method: "get",
                        useCache: true
                    })
                    .then((res,isCache) => {
                        if (res.data.status) {
                            if (!isCache) {//不是缓存的话放开loading
                                self.setLoading(false)
                            }
                            self.initData(res.data)
                        } else {
                            this.$market.alert({content: res.data.message,confirmCall () {
                                self.$router.push('/')
                            }})
                        }
                        
                    }).catch(e=>{
                        console.log(e)
                        this.$market.alert({content: '服务器错误，请稍后再试。'})
                    })
                    if (val.params.id == '27' && val.query.morderid && val.query.morderid != '') {
                        self.$store.commit('setOtherId',val.query.morderid)
                    }
                },
                immediate: true
            }
        },
        methods: {
            clearData () {
                self.ppData.name = ''
                self.ppData.notice = []
                self.ppData.price = 0
                self.ppData.configure = []
                self.ppData.authorization = []
                self.wenhuaProduct = []
                self.ppData.pic = []
            },
            initData (res) {
                let self = this
                self.ppData.name = res.data.productName
                self.ppData.stock = res.data.stock
                self.ppData.notice = res.data.productNote.split('；').filter(v=>v !='')
                self.ppData.price = res.data.price
                self.ppData.monthprice = res.data.monthprice
                self.ppData.quarterprice = res.data.quarterprice
                self.ppData.configure = res.data.sublist ? res.data.sublist.filter(v=>v.grouptype == -1) : []
                self.ppData.authorization = res.data.sublist ? res.data.sublist.filter(v=>v.grouptype != -1) : []
                self.ppData.wenhuaProduct = res.data.wenHuaProduct ? res.data.wenHuaProduct : []
                self.ppData.pic = res.data.pImgUrlList ? res.data.pImgUrlList : [] 
                self.ppData.limited = res.data.limited
                self.ppData.unit = res.data.unit
                self.ppData.isWht = res.data.isWht
                this.ppData.pwdAddress = res.data.pwdAddress
                this.$store.commit('setPic', res.data.pImgUrlList ? res.data.pImgUrlList : [])
                this.$store.commit('setProductAddress', res.data.productAddress ? res.data.productAddress : "")

            },
            buy () {
                this.initOrder();
                this.popOverShow(true);
                this.$nextTick(() => {
                    this.orderShow(true);
                    this.appOverFlow('hidden');
                })
            }
        },
        mounted () {
            
        }
    }
</script>

